<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-file-document"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="white rounded-lg mr-4">
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="projectDetail.name"
                    filled
                    label="Name"
                    placeholder="Enter project name"
                    @keyup="onKeyUp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="projectDetail.slug"
                    filled
                    label="Slug"
                    placeholder="Nhập Slug"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="projectDetail.order"
                    filled
                    label="Vị trí"
                    placeholder="Nhập vị trí"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="projectDetail.short_description"
                    filled
                    label="Mô tả ngắn"
                    placeholder="Nhập mô tả ngắn"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="my-4">Description</div>
                <ck-content :content="projectDetail.description" class="ck-project"
                            @getData="value => projectDetail.description = value"></ck-content>
              </v-col>

              <!--ảnh avatar-->
              <v-col cols="12">
                <v-file-input
                    v-model="imageAvatar"
                    label="Ảnh avatar"
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    @change="uploadImgAvatar"
                ></v-file-input>
                <v-img :class="[display_image_avatar ? 'mb-8':'d-none']"
                       :src="display_image_avatar? display_image_avatar :''" aspect-ratio="1.7"
                       contain width="200"
                ></v-img>
              </v-col>
              <!--ảnh cover-->
              <v-col cols="12">
                <v-file-input v-model="imageCover" label="Ảnh cover" laceholder="Tải ảnh lên" multiple
                              prepend-icon="mdi-camera" @change="uploadImgCover"></v-file-input>
                <div v-if="list_image_cover ">
                  <v-radio-group>
                    <v-row>
                      <v-col v-for="(img,index) in list_image_cover" :key="index" cols="3">
                        <v-row>
                          <v-col class="d-flex justify-center" cols="12">
                            <v-img
                                :src="img.url"
                                aspect-ratio="1.7"
                                contain
                            ></v-img>
                          </v-col>
                          <v-col class="d-flex justify-center" cols="12">
                            <v-btn
                                color="red"
                                fab
                                outlined
                                x-small
                                @click="clearImgCover(index,img.id)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </div>
              </v-col>
              <!-- ảnh screen-->
              <v-col cols="12">
                <v-file-input v-model="imageScreen" label="Ảnh Screen" laceholder="Tải ảnh lên" multiple
                              prepend-icon="mdi-camera" @change="uploadImgScreen"></v-file-input>
                <div v-if="list_image_cover">
                  <v-radio-group>
                    <v-row>
                      <v-col v-for="(img,index) in list_image_screen" :key="index" cols="3">
                        <v-row>
                          <v-col class="d-flex justify-center" cols="12">
                            <v-img
                                :src="img.url"
                                aspect-ratio="1.7"
                                contain
                            ></v-img>
                          </v-col>
                          <v-col class="d-flex justify-center" cols="12">
                            <v-btn
                                color="red"
                                fab
                                outlined
                                x-small
                                @click="clearImgScreen(index,img.id)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </div>
              </v-col>

            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="projectDetail.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên project "
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                    v-model="projectDetail.field_project_id"
                    :items="fields"
                    filled
                    item-text="name"
                    item-value="id"
                    label="Loại project"
                ></v-select>
              </v-col>
              <v-col cols="12" style="margin-bottom: 86px"></v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="projectDetail.short_description_vi"
                    filled
                    label="Mô tả ngắn"
                    placeholder="Nhập mô tả ngắn"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="my-4">Mô tả</div>
                <ck-content :content="projectDetail.description_vi" class="ck-project"
                            @getData="value => projectDetail.description_vi = value"></ck-content>
              </v-col>
              <!-- link-->
              <v-col cols="12">
                <v-row class="pl-3 py-3">
                  <h4 class="grey--text text--darken-4 text-decoration-underline">Link </h4>
                  <v-icon class="pl-1" @click="addLink">mdi-plus-box</v-icon>
                </v-row>
                <div v-for="(item, index) in list_link" :key="index">
                  <v-row class="mt-1" width="100%">
                    <v-col cols="3">
                      <v-text-field
                          v-model="item.type_link"
                          filled
                          label="Loại Link"
                          placeholder="Nhập loại link"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                          v-model="item.link"
                          filled
                          label="Link"
                          placeholder="Nhập Link"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn class="btn-recycle rounded-lg" height="58" @click="clearBlock(index)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12">
                <h4 class="mb-2">Project tags</h4>
                <v-divider></v-divider>
                <div>
                  <v-select
                      v-model="list_tag_id"
                      :items="list_tags"
                      chips
                      item-text="name"
                      item-value="id"
                      label="Tags"
                      multiple
                      outlined
                  ></v-select>
                </div>
              </v-col>

              <v-col cols="12">
                <v-text-field
                    v-model="projectDetail.phone"
                    filled
                    label="SĐT"
                    placeholder="Nhập SĐT"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="projectDetail.email"
                    filled
                    label="Email"
                    placeholder="Nhập email"
                ></v-text-field>
              </v-col>
            </v-col>
          </v-row>
          <v-col class="d-flex justify-center" cols="12">
            <v-btn class="px-10" color="primary" elevation="6" width="180" @click="save">LƯU</v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import CkContent from "@/components/ck-content";
import {mapGetters} from "vuex";
import {GET_DETAIL_PROJECT, UPDATE_PROJECT} from "@/store/modules/project";
import {GET_LIST_TAGS} from "@/store/modules/tags";
import {GET_LIST_FIELD_PROJECT, UPLOAD_IMAGE, UPLOAD_LIST_IMAGE} from "@/store/modules/field_project";
import validateSlug from "@/mixins/validateSlug";

export default {
  name: "Edit_project",
  mixins: [validateSlug],
  components: {
    CkContent
  },
  data() {
    return {
      page: "Sửa project",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Projects",
          disabled: true,
        },
        {
          text: "Sửa project",
          disabled: false,
        },
      ],
      url: '',
      list_tags: [],
      list_tag_id: [],
      project: {
        name: '',
        slug: '',
        description: '',
        field_project_id: '',
        link: '',
        photo_url: '',
        tags: [],
        photo_project: [],
        short_description: ''
      },
      //image Cover
      imageCover: null,
      list_image_cover: [],
      listImgCover: [],
      update_Cover: [],
      updateCover: false,
      //image Avatar
      imageAvatar: null,
      display_image_avatar: '',
      //imageScreen
      imageScreen: null,
      list_image_screen: [],
      listImgScreen: [],
      update_Screen: false,
      updateScreen: [],

      list_link: [],
      block_links: {
        type_link: '',
        link: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      projectDetail: "projectDetail",
      tags: "tags",
      fields: "fields",
    }),

  },
  watch: {
    projectDetail(val) {
      if (val && val.photo_url) {
        this.display_image_avatar = this.url + val.photo_url;
      }
    },
    tags(val) {
      if (val) {
        val.forEach((el) => {
          this.list_tags.push({
            id: el.id,
            name: el.name,
          });
        });
      }
    },
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_DETAIL_PROJECT, this.$route.params.id);
    await this.$store.dispatch(`${GET_LIST_TAGS}`);
    await this.$store.dispatch(`${GET_LIST_FIELD_PROJECT}`);
    if (this.projectDetail && this.projectDetail.tags) {
      this.projectDetail.tags.forEach((el) => {
        this.list_tag_id.push(el.id);
      });
    }
    this.projectDetail.photo_project.forEach((el) => {
      if (el.position_type == 1) {
        this.list_image_cover.push({
          id: el.id,
          url: el.path,
        })
      } else if (el.position_type == 2) {
        this.list_image_screen.push({
          id: el.id,
          url: el.path,
        })
      }
    });
    if (this.projectDetail && this.projectDetail.link) {
      JSON.parse(this.projectDetail.link).forEach((el) => {
        this.list_link.push(el)
      });
    }

  },
  methods: {
    onKeyUp(value){
      this.projectDetail.slug = this.sanitizeTitle(value.target.value)
    },
    uploadImgAvatar(e) {
      if (!e) {
        this.display_image_avatar = "";
        this.projectDetail.photo_url = "";
      }
      this.display_image_avatar = URL.createObjectURL(e)
      this.$forceUpdate()
    },
    uploadImgCover(e) {
      this.updateCover = true
      e.forEach((element, index) => {
        this.list_image_cover.push({
          'index': index,
          'url': URL.createObjectURL(element),
          'ob': element
        })
      });
      this.$forceUpdate()
    },
    uploadImgScreen(e) {
      this.updateScreen = true
      e.forEach((element, index) => {
        this.list_image_screen.push({
          'index': index,
          'url': URL.createObjectURL(element),
          'ob': element
        })
      });
      this.$forceUpdate()
    },

    clearImgCover(index, id) {
      this.list_image_cover.splice(index, 1)
      this.projectDetail.photo_project = this.projectDetail.photo_project.filter(item => item.id != id)
      this.$forceUpdate()
    },
    clearImgScreen(index,id) {
      this.list_image_screen.splice(index, 1)
      this.projectDetail.photo_project = this.projectDetail.photo_project.filter(item => item.id != id)
      this.$forceUpdate()
    },

    addLink() {
      this.list_link.push({
            'type_link': this.block_links.type_link,
            'link': this.block_links.link
          }
      )
    },
    clearBlock(i) {
      this.list_link.splice(i, 1)
      this.$forceUpdate()
    },

    async save() {
      //upload Avatar
      if (this.imageAvatar != null) {
        let formDateAvatar = new FormData();
        formDateAvatar.append("upload", this.imageAvatar);
        formDateAvatar.append("type", "ckeditor");
        formDateAvatar.append("position_type", "1");
        await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
              if (data.data.status == 1) {
                this.projectDetail.photo_url = data.data.data[0].path
              }
            }
        )
      }
      //upload list image Cover
      if (this.imageCover && this.imageCover.length >= 0) {
        this.listImgCover = this.list_image_cover.filter(item => item.ob != null)
        this.list_image_cover = this.projectDetail.photo_project.filter(item => item.position_type == 1)
        let formData = new FormData();
        if (this.listImgCover) {
          this.listImgCover.forEach(e => {
            formData.append(`upload[]`, e.ob);
          })
        }
        formData.append("type", "ckeditor");
        formData.append("position_type", "1");
        await this.$store.dispatch(`${UPLOAD_LIST_IMAGE}`, formData).then((data) => {
          if (data.data.status == 1) {
            data.data.data.forEach(el => {
              this.list_image_cover.push({
                    id: el.media_id,
                    url: el.url
                  }
              );
            })
          }
        });
      }

      //Upload list image Screen
      if (this.imageScreen && this.imageScreen.length >= 0) {
        this.listImgScreen = this.list_image_screen.filter(item => item.ob != null)
        this.list_image_screen = this.projectDetail.photo_project.filter(item => item.position_type == 2)
        let formData1 = new FormData();
        if (this.listImgScreen) {
          this.listImgScreen.forEach(e => {
            formData1.append(`upload[]`, e.ob);
          })
        }
        formData1.append("type", "ckeditor");
        formData1.append("position_type", "2");
        await this.$store.dispatch(`${UPLOAD_LIST_IMAGE}`, formData1).then((data) => {
          if (data.data.status == 1) {
            data.data.data.forEach(el => {
              this.list_image_screen.push({
                    id: el.media_id,
                    url: el.url
                  }
              );
            })
          }
        });
      }

      //list tags
      this.projectDetail.tags = []
      const _this = this;
      this.list_tag_id.forEach(id => {
        let tag = _this.list_tags.find(el => el.id == id)
        _this.projectDetail.tags.push(tag.id)
      })
      //save_image
      this.projectDetail.photo_project = []
      this.projectDetail.photo_project = [].concat(this.list_image_cover, this.list_image_screen)
      let data = {
        id: this.$route.params.id,
        name: this.projectDetail.name,
        name_vi: this.projectDetail.name_vi,
        slug: this.projectDetail.slug,
        short_description_vi: this.projectDetail.short_description_vi,
        short_description: this.projectDetail.short_description,
        field_project_id: this.projectDetail.field_project_id,
        link: JSON.stringify(this.list_link),
        photo_url: this.projectDetail.photo_url,
        tags: this.projectDetail.tags,
        photo_projects: this.projectDetail.photo_project,
        description: this.projectDetail.description,
        description_vi: this.projectDetail.description_vi,
        active: this.projectDetail.active,
        phone: this.projectDetail.phone,
        email: this.projectDetail.email,
        order: this.projectDetail.order
      }
      await this.$store.dispatch(`${UPDATE_PROJECT}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/project_management/project')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }

}
</script>

<style scoped>

</style>